import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Stack,
    IconButton,
    InputAdornment,
    Box
  } from "@mui/material";
  import { Visibility, VisibilityOff } from "@mui/icons-material";
  import { useState } from "react";
  import Synology from 'assets/images/auth/synology_logo_result.webp';
  
  export default function LoginSynologyDialog({
    open,
    onCancel,
    onConfirm,
    connectorName = "Connector"
  }) {
    const [form, setForm] = useState({
      userId: "",
      password: "",
      projectId: ""
    });
  
    const [showPassword, setShowPassword] = useState(false);
  
    const handleChange = (e) => {
      setForm(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));
    };
  
    const handleSubmit = () => {
      onConfirm(form); // 👈 send all inputs
    };
  
    return (
      <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>

        <DialogContent>
        {/* 🔹 Connector Image */}
          <Box
            display="flex"
            justifyContent="center"
            mb={2}
          >
            <Box
              component="img"
              src={Synology}
              alt={"synology"}
              sx={{
                width: 150,
                height: 100,
                objectFit: "contain"
              }}
            />
          </Box>

        <Stack spacing={2}>
          <TextField
            label="User ID"
            name="userId"
            value={form.userId}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Password"
            name="password"
            type={showPassword ? "text" : "password"}
            value={form.password}
            onChange={handleChange}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(v => !v)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Synology URL"
            name="projectId"
            value={form.projectId}
            onChange={handleChange}
            fullWidth
          />
        </Stack>
      </DialogContent>
  
        <DialogActions>
          <Button onClick={onCancel} color="inherit">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!form.userId || !form.password || !form.projectId}
          >
            Connect
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  